import { IHeaderParams } from "@ag-grid-community/core";
import { Box, HStack, Text, Tooltip } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FundFamilyUseAllocationTableContext } from "shared/components/fund-family-use-allocation/FundFamilyUseAllocationTableProps";
import { InfoCircleIcon } from "shared/icons/InfoCircleIcon";

export const FundFamilyUseAllocationTableAutoAllocateHeader: React.FC<
  IHeaderParams
> = (params) => {
  const { t } = useTranslation(["common"]);
  const tooltipLabel =
    (params.context as FundFamilyUseAllocationTableContext)
      .autoAllocateTooltip ?? t("common:drawdown.autoAllocateTooltip");
  return (
    <Box className="ag-cell-label-container">
      <Box className="ag-header-cell-label">
        <HStack gap="6px" w="100%" justifyContent="center">
          <Text as="span" className="ag-header-cell-text">
            {params.displayName}
          </Text>
          <Tooltip label={tooltipLabel}>
            <InfoCircleIcon w="14px" h="14px" />
          </Tooltip>
        </HStack>
      </Box>
    </Box>
  );
};
